import { Alert } from "reactstrap";

export function ProductInputPreview({ items }: { items: any[] })
{
    if (!items || items.length === 0)
    {
        return null;
    }

    return (
        <div className="mt-4">
            <h5>Aktualny ProductInput</h5>

            {items.map((item, index) => (
                <div key={`${item.productId}-${item.profileId}-${index}`} className="mb-4">
                    <div className="mb-2">
                        <strong>Produkt:</strong> {item.productId}
                        {' '}
                        <strong>Profil:</strong> <code>{item.profileId}</code>
                    </div>

                    {item.error && (
                        <Alert color="danger">{item.error}</Alert>
                    )}

                    {item.response?.warnings && item.response.warnings.length > 0 && (
                        <Alert color="warning">
                            <strong>Ostrzeżenia:</strong>
                            <ul className="mb-0">
                                {item.response.warnings.map((warning: string, warningIndex: number) => (
                                    <li key={warningIndex}>{warning}</li>
                                ))}
                            </ul>
                        </Alert>
                    )}

                    <details open={items.length === 1}>
                        <summary>Payload / raw JSON</summary>
                        <pre className="mt-3">{JSON.stringify(item.response ?? item, null, 2)}</pre>
                    </details>
                </div>
            ))}
        </div>
    );
}